import { Text } from 'rebass/styled-components'
import styled from 'styled-components'

const OverflowText = styled(Text)`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${({ line }) => line || 2};
    overflow: hidden;
`

export default OverflowText
